import AppModel from 'Models/AppModel';
import axios from 'axios';

const { API_URI } = AppModel;

// eslint-disable-next-line import/prefer-default-export
export async function applyPromocode({
  promocode = '', regionId, productId = '', userEmail = null,
}) {
  if (!promocode) {
    return Promise.reject();
  }

  const params = new URLSearchParams({
    region_id: regionId,
  });

  if (productId) {
    params.append('pid', productId);
  }

  if (userEmail) {
    params.append('email', userEmail);
  }

  return axios.get(`${API_URI}/promocodes/info/${promocode}?${params.toString()}`);
}
